import { Text } from "@/components/ui/text";
import { View } from "@/components/ui/view";
import { Image } from "@/components/ui/image";
import i18n from 'i18n-js';
import { Video } from 'expo-av';
import React, { useState } from 'react';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import speechbox from "../../assets/images/speechbox.png";
// import InAInfoPose from "../../assets/images/InAInfoLaserB2x.png";
// import InAPlanPose from "../../assets/images/InAPlanLaserB2x.png";
import InAInfoPose from "../../assets/images/InAInfoLaserB2.png";
import InAPlanPose from "../../assets/images/InAPlanLaserB2.png";
import InADonePose from "../../assets/images/InADone.png";
import InAThumbPose from "../../assets/images/InAThumbB2.png";
import InAInvitePose from "../../assets/images/InAInviteB2.png";
// import InADanceVideo from "../../assets/images/InASanta.mp4";
// import InADanceVideo from "../../assets/images/InATwistDanceB.mp4";
import InADanceVideoFix from "../../assets/images/InATwistDanceB.mp4";
import InASwingDancePose from "../../assets/images/InASwingDance.png";
import { useWindowDimensions, Platform } from 'react-native';
import { useSelector } from 'react-redux';
import FloatingLabelInput from './FloatingLabelInput';
import InAWinter from './InAWinter';
import InAEaster from './InAEaster';

const poses = [{ uri: InAInfoPose, type: 0 }, { uri: InAPlanPose, type: 0 }, { uri: InADanceVideoFix, type: 1 }, { uri: InASwingDancePose, type: 0 }, { uri: InADonePose, type: 0 }, { uri: InAInvitePose, type: 0 }, { uri: InAThumbPose, type: 0 }]

const textHeights = [ 'h-[100px]', 'h-[150px]', 'h-[200px]', 'h-[250px]', 'h-[300px]', 'h-[350px]', 'h-[400px]' ];

export default function InAInfo({ info, pose, asHint }) {
  const insets = useSafeAreaInsets()
  const window = useWindowDimensions()
  const [height, setHeight] = useState(textHeights[0])
  const [viewWidth, setViewWidth] = useState(0)
  const effectiveWidth = viewWidth || window.width
  const sizes = effectiveWidth >= 800 ?
    { hAdd: 80, mx: 'mx-12', bottom: insets.bottom + 30, videoHeight: '100%', imageHeight: 'h-[85%]', scale: 0.2, off: 50, beg: 450 } :
    { hAdd: 100, mx: 'mx-5', bottom: insets.bottom + 40, videoHeight: '90%', imageHeight: 'h-[80%]', scale: 0.3, off: 80, beg: 470 }

  const [ina, setIna] = useState(poses[pose])
  const settings = useSelector((state) => state.settings)

  return (settings.showInA == undefined || settings.showInA 
    ? <View className="flex-1"
        onLayout={(e) => {
          const width = Math.round(e.nativeEvent.layout.width)
          setViewWidth((currentWidth) => currentWidth == width ? currentWidth : width)
        }}
      >
        {ina.type == 0 
          ? <>
              <Image key='A' resizeMode='cover' source={ina.uri} alt={i18n.t('global.missingImage')} className={`absolute bottom-5 w-[100%] ${sizes.imageHeight}`} />
              {/* {Platform.OS !== 'web' && ina.type == 0 && (settings.showSpecials == undefined || settings.showSpecials) && <InAEaster sizes={sizes}/>} */}
            </>
          : <Video source={ina.uri} key={Math.random()} style={{ position: 'absolute', bottom: 0, width: '100%', height: sizes.videoHeight }} videoStyle={{width: '100%', height: '100%' }} resizeMode='cover' useNativeControls={false} isLooping={true} shouldPlay={true} />
        }
        {info && <>
          <Image source={speechbox} resizeMode='stretch' alt={i18n.t('global.missingImage')} className={`absolute ${height} w-[100%]`} />
          <View className={`${sizes.mx} mt-6`}>
            <View className="px-2 rounded-[8px]"
              onLayout={(e) => {
                console.log(textHeights[Math.min(textHeights.length -1, Math.ceil(e.nativeEvent.layout.height / 50))]); 
                setHeight(textHeights[Math.min(textHeights.length -1, Math.ceil(e.nativeEvent.layout.height / 50))])}}>
              <Text className={`font-normal text-lg text-secondary-900 z-10`}>{info}</Text>
            </View>
          </View>
        </>}
      </View> 
    : asHint 
      ? <FloatingLabelInput label={i18n.t('accountSettings.hint')} box='mt-10 mx-3' multiline={true} isDisabled={true} value={info} /> 
      : <Text className="p-3 mt-3 text-xl text-secondary-900">{info}</Text>)
}
